import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginModule } from './features/login/login.module';
import { AppInitService } from 'src/app/core/services/app-init.service';
import { CommonModule } from '@angular/common';
import { CoreModule } from './core/core.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ModalModule } from 'ngx-bootstrap/modal';
import { OverlayModule } from '@angular/cdk/overlay';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { ApplicationInsightsService } from './core/services/application-insights.service';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalBroadcastService, MsalGuard, MsalInterceptor, MsalService } from '@azure/msal-angular';
import { MSALGuardConfigFactory, MSALInstanceFactory, MSALInterceptorConfigFactory, MvMsalService } from '@aot/host-app-widgets-demo';
import { MvRouteGuardService } from './core/services/msal/guards/mv-route-guard.service';

export function loadConfigurations(configService: AppInitService) {
  return () => configService.loadConfiguration();
}
@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    LoginModule,
    HttpClientModule,
    CommonModule,
    CoreModule,
    BrowserAnimationsModule,
    ModalModule.forRoot(),
    OverlayModule,
    MatCheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    MatMenuModule
  ],
  providers: [
    AppInitService,
    {
      provide: APP_INITIALIZER,
      useFactory: loadConfigurations,
      deps: [AppInitService, HttpClient],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,  // <-- Apply MSAL interceptor first for token acquisition
      multi: true
  },
  {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory  // <-- Configure MSAL instance for authentication
  },
  {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory  // <-- Configure MSAL Guard
  },
  {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory  // <-- Configure MSAL interceptor
  },
  MsalService,
  MsalGuard,
  MvRouteGuardService,
  MvMsalService,
  MsalBroadcastService,
    ApplicationInsightsService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }